import React, { memo, HTMLProps } from 'react';
import classnames from 'classnames';
import { SIZE } from '@zmedia/bm-soccer-ui/constants';
import Element from '../../element';
import styles from './icons.module.scss';
interface IProps extends HTMLProps<HTMLSpanElement> {
    icon?: string | React.ReactNode;
    isSize?: SIZE;
    color?: string;
    align?: 'left' | 'right';
    className?: string;
    renderAs?: string;
    domRef?: any;
    type?: 'bm' | 'font';
}

function Icon({
    icon,
    isSize,
    color,
    className,
    align,
    type = 'font',
    ...rest
}: IProps) {
    const iconClass = styles[`ic-${icon}`]
        ? styles[`ic-${icon}`]
        : [`ic-${icon}`];
    const typeClass = type === 'bm' ? styles['bm-icon'] : styles['icon'];
    if (typeof icon === 'string') {
        return (
            <Element
                renderAs="i"
                {...rest}
                className={classnames(typeClass, className, {
                    [`is-${isSize}`]: isSize,
                    [`is-${align}`]: align,
                    [`has-text-${color}`]: color,
                    [`${iconClass}`]: icon,
                })}
            />
        );
    }

    return (
        <Element
            renderAs="i"
            className={classnames(typeClass, className, {
                [`is-${isSize}`]: isSize,
                [`is-${align}`]: align,
                [`has-text-${color}`]: color,
            })}
            {...rest}
        >
            {icon}
        </Element>
    );
}

export default memo(Icon);
